import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { getAuthToken } from "../api/AuthHeaders";

export const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    // Change this to your upload POST address:
    url: "/File/TemporaryUpload",
    acceptedFiles: 'image/*',
    headers: {
        "Authorization": "Bearer " + getAuthToken()
    },
    clickable: false
};
